export const WIX_DOMAIN = 'wix.com';
export const EDITORX_DOMAIN = 'editorx.com';

export const USER_LOGIN_PARAM = 'loggedIn';
export const TEMPLATE_CHECKOUT_SITE_ID = '548f7aff-604e-45a3-92c5-7e3b7f7f1a67';
export const TEMPLATE_CHECKOUT_APP_ID = 'f6e7302a-049c-45a2-a116-ee40aac719b0';
export const ARTIFACT_ID = 'partners-marketplace-nextjs';
export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_CURRENCY_SYMBOL = '$';
export const MAX_PRICE_IN_USD = 20000;
export const MIN_PRICE = 0;
export const MARKETPLACE_URL = '/marketplace/';
export const MAX_ABOUT_LENGTH = 256;
export const MAX_CHARS_IN_REVIEW = 200;
export const MAX_CHARS_IN_ABOUT_MOBILE = 200;
export const MAX_LINES_IN_ABOUT = 6;
export const MAX_CHARS_IN_PROJECT_DESCRIPTION_MOBILE = 190;
export const MAX_CHARS_IN_PROJECT_DESCRIPTION_DESKTOP = 620;
export const PROJECT_MODAL_CLOSE_ANIMATION_DURATION = 400;
export const BRIEF_PAGE = 'brief-auto-match';
export const BRIEF_URL = `https://www.wix.com/marketplace/${BRIEF_PAGE}`;
export const TEMPLATES_API_URL = '/api/templates';
export const SITE_LIST_API_URL = '/api/getSitesList';
export const TEMPLATE_REDEMPTION_API_URL = '/api/template/redemption';
export const SUBMIT_PARTNER_DISPUTE_API_URL =
  '/api/disputes/submitPartnerDispute';
export const REPORT_TEMPLATE_API_URL = '/api/template/reportTemplate';
export const TEMPLATE_POST_REVIEW_API_URL = '/api/template/review';
export const TEMPLATE_DELETE_REVIEW_API_URL = '/api/template/deleteReview';
export const TEMPLATE_UPDATE_REVIEW_API_URL = '/api/template/updateReview';
export const TEMPLATE_POST_REVIEW_REPLY_API_URL =
  '/api/template/writeReviewReply';
export const TEMPLATE_DELETE_REVIEW_REPLY_API_URL =
  '/api/template/deleteReviewReply';
export const TEMPLATE_CHECKOUT_API_URL = '/api/template/checkout';
export const FILL_JOB_BRIEF_URL = '/_api/marketplace-webapp/fillJobBrief';
export const SUBMIT_DIRECT_BRIEF_URL =
  '/_api/marketplace-webapp/submitJobRequest';
export const SUBMIT_BRIEF_DIRECT_URL = '/api/submitBrief/direct';
export const SUBMIT_BRIEF_ADDITIONAL_PROJECT_URL =
  '/api/submitBrief/additional-project';
export const SUBMIT_AUTO_MATCH_BRIEF_URL = '/api/submitBrief/auto-match';
export const TERMS_OF_USE_URL = 'https://www.wix.com/marketplace/terms-of-use';
export const SEO_SOCIALS_IMAGE =
  'https://static.wixstatic.com/media/375882_750a887236d5435cad3ce1cdc20050d6~mv2.jpg';
export const REPLY_TO_REVIEW_URL = '/_api/marketplace-webapp/addReplyToReview/';
export const EXPLORE_URL = 'https://www.wix.com/marketplace/hire';
export const FEATURED_PROJECT_PAGE_PREFIX = 'featured-project';
export const FEATURED_PROJECT_URL_PREFIX = `https://www.wix.com/marketplace/${FEATURED_PROJECT_PAGE_PREFIX}`;
export const FEATURED_PROJECT_FETCH_URLS_API_URL = `featured-project/api/fetchProjectsUrls`;
export const STUDIO_SITES_URL = 'https://manage.wix.com/studio/sites';
export const TAX_GROUP_ID = 'f6e7302a-049c-45a2-a116-ee40aac719b0';

export const MY_PROJECTS = 'my-projects';
export const PARTNER_PROFILE = 'studio/community/partners';
export const TEMPLATES_GALLERY_ENTRY = 'gallery_page';
export const STUDIO_DASHBOARD_TEMPLATES_ENTRY = 'custom_templates_gallery';
export const STUDIO_DASHBOARD_COMMUNITY_TEMPLATES =
  'Template page - by the community';
export const MARKETPLACE_ENTRY = 'marketplace-gate';
export const MARKETPLACE_HEADER_ENTRY = 'marketplace_header';
export const CUSTOM_TEMPLATES_WORKSPACE_ENTRY = 'custom-templates';
export const COMMUNITY_TEMPLATES_WORKSPACE_ENTRY =
  'studio-templates-by-the-community';

export const CLIENT_PROJECTS_PORTFOLIO_INITIAL_DISPLAY = 8; // 3 + 2 + 3 for the first three rows
export const CLIENT_PROJECTS_PORTFOLIO_INCREMENT = 9; // Additional rows show 8 projects each
export const CLIENT_PROJECTS_PORTFOLIO_MOBILE_INCREMENT = 6; // Mobile view shows 3 additional projects

export const enableInternalMarketplaceSpec =
  'com.wixpress.experts.lib.callscope.enrich.EnableInternalMarketplace';
export const ENABLE_HIDE_VELO_MODAL_SPEC =
  'specs.experts.showCheckoutSlotOnCheckoutPage';

export const SHOULD_SUPPORT_HINDI_SPEC = 'specs.marketplace.shouldSupportHindi';

export const studioCustomTemplatesPage =
  'https://manage.wix.com/studio/my-templates';

export const studioCommunityTemplatesPage =
  'https://manage.wix.com/studio/my-templates/community-templates';

export const PROFILE_MAX_VISIBLE_SERVICES = 3;
export const PROFILE_MAX_VISIBLE_CERTIFICATIONS_SHORT_DESKTOP = 2;
export const PROFILE_POPOVER_MAX_WIDTH = 407;
export const PROFILE_POPOVER_MIN_WIDTH = 180;
export const PROFILE_CERTIFICATIONS_CAROUSEL_BREAKPOINT = 3;
export const PROFILE_CERTIFICATIONS_LIMIT_SLIDE = 3;

export const CATEGORY_PATH_NAMES = {
  WEB_DESIGN: 'web-design',
  SMALL_TASKS: 'small-tasks',
  ONLINE_STORE: 'online-store',
  WEB_DEVELOPER: 'web-developer',
  MARKETING_PROMOTING: 'marketing-promoting',
  GRAPHIC_DESIGNER: 'graphic-designer',
} as const;

export const SERVICE_PATH_NAMES = {
  // Web Design services
  CLASSIC_WEBSITE: 'classic-website',
  ADVANCED_WEBSITE: 'advanced-website',
  REDESIGN_WEBSITE: 'redesign-website',
  MIGRATE_WEBSITE: 'migrate-website',
  MOBILE_WEBSITE: 'mobile-website',
  EDITOR_X_BUILD_FROM_SCRATCH: 'editor-x-build-from-scratch',
  EDITOR_X_REDESIGN_MY_SITE: 'editor-x-redesign-my-site',
  EDITOR_X_CUSTOMIZE_BREAKPOINTS: 'editor-x-customize-breakpoints',
  EDITOR_X_BUILD_MY_DESIGN: 'editor-x-build-my-design',
  // Small Tasks services
  CONNECT_DOMAIN: 'connect-domain',
  SITE_UPDATES: 'site-updates',
  WEBSITE_GUIDANCE: 'website-guidance',
  INSTALL_APPS: 'install-apps',
  CUSTOM_EMAIL: 'custom-email',
  FACEBOOK_PIXEL: 'facebook-pixel',
  GOOGLE_ANALYTICS: 'google-analytics',
  ACCESSIBILITY: 'accessibility',
  RESTAURANT_MENU_SETUP: 'restaurant-menu-setup',
  // Online Store services
  ECOMMERCE_WEBSITE_DESIGN: 'ecommerce-website-design',
  ADVANCED_STORE_CAPABILITIES: 'advanced-store-capabilities',
  STORE_SETTINGS: 'store-settings',
  STORE_OPTIMIZATION: 'store-optimization',
  // Web Developer services
  CODING_GUIDANCE: 'coding-guidance',
  CUSTOM_SITE_FUNCTIONALITIES: 'custom-site-functionalities',
  THIRD_PARTY_SERVICES: 'third-party-services',
  CONTENT_WITH_DATABASE: 'content-with-database',
  CUSTOM_INPUT_FORMS: 'custom-input-forms',
  CUSTOM_DESIGN_AND_BEHAVIOR: 'custom-design-and-behavior',
  // Marketing & Promoting services
  SEO_SERVICES: 'seo-services',
  AD_SETUP: 'ad-setup',
  CONTENT_WRITER: 'content-writer',
  EMAIL_MARKETING: 'email-marketing',
  // Graphic Designer services
  LOGO_DESIGN_SERVICES: 'logo-design-services',
  EDIT_IMAGE: 'edit-image',
  VISUAL_CONTENT: 'visual-content',
  BRAND_DEVELOPMENT: 'brand-development',
  PROFESSIONAL_PHOTOGRAPHY: 'professional-photography',
  // Mobile App service
  MOBILE_APP: 'mobile-app',
} as const;

/**
 * SEO Settings Type Definitions
 * Categories have all fields required, services can have partial fields
 */
export type SeoSettings = {
  title: string;
  description: string;
  h1: string;
};

export type ServiceSeoSettings = Partial<SeoSettings>;

/**
 * Category-level SEO settings (base templates)
 * All fields are required at category level
 */
export const CATEGORY_SEO_SETTINGS: Record<
  keyof typeof CATEGORY_PATH_NAMES,
  SeoSettings
> = {
  WEB_DESIGN: {
    title: 'seo-explore-page-title-webdesign',
    description: 'seo-explore-page-description-webdesign',
    h1: 'explore-page-heading-webdesign',
  },
  SMALL_TASKS: {
    title: 'seo-explore-page-title-smalltasks',
    description: 'seo-explore-page-description-smalltasks',
    h1: 'explore-page-heading-smalltasks',
  },
  ONLINE_STORE: {
    title: 'seo-explore-page-title-onlinestore',
    description: 'seo-explore-page-description-onlinestore',
    h1: 'explore-page-heading-onlinestore',
  },
  WEB_DEVELOPER: {
    title: 'seo-explore-page-title-webdev',
    description: 'seo-explore-page-description-webdev',
    h1: 'explore-page-heading-webdev',
  },
  MARKETING_PROMOTING: {
    title: 'seo-explore-page-title-marketingandpromoting',
    description: 'seo-explore-page-description-marketingandpromoting',
    h1: 'explore-page-heading-marketingandpromoting',
  },
  GRAPHIC_DESIGNER: {
    title: 'seo-explore-page-title-graphicdesign',
    description: 'seo-explore-page-description-graphicdesign',
    h1: 'explore-page-heading-graphicdesign',
  },
};

export const SERVICE_SEO_SETTINGS: Partial<
  Record<keyof typeof SERVICE_PATH_NAMES, ServiceSeoSettings>
> = {
  MOBILE_WEBSITE: {
    title: 'seo-explore-page-title-mobile-website',
    description: 'seo-explore-page-description-mobile-website',
  },
  ACCESSIBILITY: {
    title: 'seo-explore-page-title-accessibility',
    description: 'seo-explore-page-description-accessibility',
  },
  CUSTOM_EMAIL: {
    title: 'seo-explore-page-title-custom-email',
    description: 'seo-explore-page-description-custom-email',
  },
  FACEBOOK_PIXEL: {
    title: 'seo-explore-page-title-facebook-pixel',
    description: 'seo-explore-page-description-facebook-pixel',
  },
  GOOGLE_ANALYTICS: {
    title: 'seo-explore-page-title-google-analytics',
    description: 'seo-explore-page-description-google-analytics',
  },
  WEBSITE_GUIDANCE: {
    title: 'seo-explore-page-title-website-guidance',
    description: 'seo-explore-page-description-website-guidance',
  },
  STORE_SETTINGS: {
    title: 'seo-explore-page-title-store-settings',
    description: 'seo-explore-page-description-store-settings',
  },
  ECOMMERCE_WEBSITE_DESIGN: {
    title: 'seo-explore-page-title-ecommerce-website-design',
    description: 'seo-explore-page-description-ecommerce-website-design',
  },
  ADVANCED_STORE_CAPABILITIES: {
    title: 'seo-explore-page-title-advanced-store-capabilities',
    description: 'seo-explore-page-description-advanced-store-capabilities',
  },
  SEO_SERVICES: {
    title: 'seo-explore-page-title-seo-services',
    description: 'seo-explore-page-description-seo-services',
  },
  EMAIL_MARKETING: {
    title: 'seo-explore-page-title-email-marketing',
    description: 'seo-explore-page-description-email-marketing',
  },
  CONTENT_WRITER: {
    title: 'seo-explore-page-title-content-writer',
    description: 'seo-explore-page-description-content-writer',
  },
  AD_SETUP: {
    title: 'seo-explore-page-title-ad-setup',
    description: 'seo-explore-page-description-ad-setup',
  },
  VISUAL_CONTENT: {
    title: 'seo-explore-page-title-visual-content',
    description: 'seo-explore-page-description-visual-content',
  },
  PROFESSIONAL_PHOTOGRAPHY: {
    title: 'seo-explore-page-title-professional-photography',
    description: 'seo-explore-page-description-professional-photography',
  },
  LOGO_DESIGN_SERVICES: {
    title: 'seo-explore-page-title-logo-design-services',
    description: 'seo-explore-page-description-logo-design-services',
  },
  EDIT_IMAGE: {
    title: 'seo-explore-page-title-edit-image',
    description: 'seo-explore-page-description-edit-image',
  },
  BRAND_DEVELOPMENT: {
    title: 'seo-explore-page-title-brand-development',
    description: 'seo-explore-page-description-brand-development',
  },
  MOBILE_APP: {
    title: 'seo-explore-page-title-mobile-app',
    description: 'seo-explore-page-description-mobile-app',
  },
  REDESIGN_WEBSITE: {
    title: 'seo-explore-page-title-redesign-website',
  },
  MIGRATE_WEBSITE: {
    title: 'seo-explore-page-title-migrate-website',
  },
  CODING_GUIDANCE: {
    title: 'seo-explore-page-title-coding-guidance',
    description: 'seo-explore-page-description-coding-guidance',
  },
  STORE_OPTIMIZATION: {
    title: 'seo-explore-page-title-store-optimization',
    description: 'seo-explore-page-description-store-optimization',
  },
};

/**
 * Default SEO settings fallback
 */
export const DEFAULT_SEO_SETTINGS: SeoSettings = {
  title: 'seo-explore-page-title-default',
  description: 'seo-explore-page-description-default',
  h1: 'explore-page-heading-default',
};

export const SERVICE_TO_CATEGORY_MAP: Record<string, string> = {
  [SERVICE_PATH_NAMES.CLASSIC_WEBSITE]: CATEGORY_PATH_NAMES.WEB_DESIGN,
  [SERVICE_PATH_NAMES.ADVANCED_WEBSITE]: CATEGORY_PATH_NAMES.WEB_DESIGN,
  [SERVICE_PATH_NAMES.REDESIGN_WEBSITE]: CATEGORY_PATH_NAMES.WEB_DESIGN,
  [SERVICE_PATH_NAMES.MIGRATE_WEBSITE]: CATEGORY_PATH_NAMES.WEB_DESIGN,
  [SERVICE_PATH_NAMES.MOBILE_WEBSITE]: CATEGORY_PATH_NAMES.WEB_DESIGN,
  [SERVICE_PATH_NAMES.EDITOR_X_BUILD_FROM_SCRATCH]:
    CATEGORY_PATH_NAMES.WEB_DESIGN,
  [SERVICE_PATH_NAMES.EDITOR_X_REDESIGN_MY_SITE]:
    CATEGORY_PATH_NAMES.WEB_DESIGN,
  [SERVICE_PATH_NAMES.EDITOR_X_CUSTOMIZE_BREAKPOINTS]:
    CATEGORY_PATH_NAMES.WEB_DESIGN,
  [SERVICE_PATH_NAMES.EDITOR_X_BUILD_MY_DESIGN]: CATEGORY_PATH_NAMES.WEB_DESIGN,
  [SERVICE_PATH_NAMES.CONNECT_DOMAIN]: CATEGORY_PATH_NAMES.SMALL_TASKS,
  [SERVICE_PATH_NAMES.SITE_UPDATES]: CATEGORY_PATH_NAMES.SMALL_TASKS,
  [SERVICE_PATH_NAMES.WEBSITE_GUIDANCE]: CATEGORY_PATH_NAMES.SMALL_TASKS,
  [SERVICE_PATH_NAMES.INSTALL_APPS]: CATEGORY_PATH_NAMES.SMALL_TASKS,
  [SERVICE_PATH_NAMES.CUSTOM_EMAIL]: CATEGORY_PATH_NAMES.SMALL_TASKS,
  [SERVICE_PATH_NAMES.FACEBOOK_PIXEL]: CATEGORY_PATH_NAMES.SMALL_TASKS,
  [SERVICE_PATH_NAMES.GOOGLE_ANALYTICS]: CATEGORY_PATH_NAMES.SMALL_TASKS,
  [SERVICE_PATH_NAMES.ACCESSIBILITY]: CATEGORY_PATH_NAMES.SMALL_TASKS,
  [SERVICE_PATH_NAMES.RESTAURANT_MENU_SETUP]: CATEGORY_PATH_NAMES.SMALL_TASKS,
  [SERVICE_PATH_NAMES.ECOMMERCE_WEBSITE_DESIGN]:
    CATEGORY_PATH_NAMES.ONLINE_STORE,
  [SERVICE_PATH_NAMES.ADVANCED_STORE_CAPABILITIES]:
    CATEGORY_PATH_NAMES.ONLINE_STORE,
  [SERVICE_PATH_NAMES.STORE_SETTINGS]: CATEGORY_PATH_NAMES.ONLINE_STORE,
  [SERVICE_PATH_NAMES.STORE_OPTIMIZATION]: CATEGORY_PATH_NAMES.ONLINE_STORE,
  [SERVICE_PATH_NAMES.CODING_GUIDANCE]: CATEGORY_PATH_NAMES.WEB_DEVELOPER,
  [SERVICE_PATH_NAMES.CUSTOM_SITE_FUNCTIONALITIES]:
    CATEGORY_PATH_NAMES.WEB_DEVELOPER,
  [SERVICE_PATH_NAMES.THIRD_PARTY_SERVICES]: CATEGORY_PATH_NAMES.WEB_DEVELOPER,
  [SERVICE_PATH_NAMES.CONTENT_WITH_DATABASE]: CATEGORY_PATH_NAMES.WEB_DEVELOPER,
  [SERVICE_PATH_NAMES.CUSTOM_INPUT_FORMS]: CATEGORY_PATH_NAMES.WEB_DEVELOPER,
  [SERVICE_PATH_NAMES.CUSTOM_DESIGN_AND_BEHAVIOR]:
    CATEGORY_PATH_NAMES.WEB_DEVELOPER,
  [SERVICE_PATH_NAMES.MOBILE_APP]: CATEGORY_PATH_NAMES.WEB_DESIGN,
  [SERVICE_PATH_NAMES.SEO_SERVICES]: CATEGORY_PATH_NAMES.MARKETING_PROMOTING,
  [SERVICE_PATH_NAMES.AD_SETUP]: CATEGORY_PATH_NAMES.MARKETING_PROMOTING,
  [SERVICE_PATH_NAMES.CONTENT_WRITER]: CATEGORY_PATH_NAMES.MARKETING_PROMOTING,
  [SERVICE_PATH_NAMES.EMAIL_MARKETING]: CATEGORY_PATH_NAMES.MARKETING_PROMOTING,
  [SERVICE_PATH_NAMES.LOGO_DESIGN_SERVICES]:
    CATEGORY_PATH_NAMES.GRAPHIC_DESIGNER,
  [SERVICE_PATH_NAMES.EDIT_IMAGE]: CATEGORY_PATH_NAMES.GRAPHIC_DESIGNER,
  [SERVICE_PATH_NAMES.VISUAL_CONTENT]: CATEGORY_PATH_NAMES.GRAPHIC_DESIGNER,
  [SERVICE_PATH_NAMES.BRAND_DEVELOPMENT]: CATEGORY_PATH_NAMES.GRAPHIC_DESIGNER,
  [SERVICE_PATH_NAMES.PROFESSIONAL_PHOTOGRAPHY]:
    CATEGORY_PATH_NAMES.GRAPHIC_DESIGNER,
};

const SERVICE_PATH_TO_KEY_MAP: Record<string, keyof typeof SERVICE_PATH_NAMES> =
  Object.entries(SERVICE_PATH_NAMES).reduce((acc, [key, pathName]) => {
    acc[pathName] = key as keyof typeof SERVICE_PATH_NAMES;
    return acc;
  }, {} as Record<string, keyof typeof SERVICE_PATH_NAMES>);

const CATEGORY_PATH_TO_KEY_MAP: Record<
  string,
  keyof typeof CATEGORY_PATH_NAMES
> = Object.entries(CATEGORY_PATH_NAMES).reduce((acc, [key, pathName]) => {
  acc[pathName] = key as keyof typeof CATEGORY_PATH_NAMES;
  return acc;
}, {} as Record<string, keyof typeof CATEGORY_PATH_NAMES>);

export function mergeSeoSettings(
  serviceSettings: ServiceSeoSettings | undefined,
  categorySettings: SeoSettings | undefined,
): SeoSettings {
  const base = categorySettings ?? DEFAULT_SEO_SETTINGS;

  if (!serviceSettings) {
    return base;
  }

  return {
    title: serviceSettings.title ?? base.title,
    description: serviceSettings.description ?? base.description,
    h1: serviceSettings.h1 ?? base.h1,
  };
}

export function getSeoSettingsForService(servicePathName: string): SeoSettings {
  const serviceKey = SERVICE_PATH_TO_KEY_MAP[servicePathName];
  const serviceSettings = serviceKey
    ? SERVICE_SEO_SETTINGS[serviceKey]
    : undefined;

  const categoryPathName = SERVICE_TO_CATEGORY_MAP[servicePathName];
  if (!categoryPathName) {
    return mergeSeoSettings(serviceSettings, undefined);
  }

  const categoryKey = CATEGORY_PATH_TO_KEY_MAP[categoryPathName];
  const categorySettings = categoryKey
    ? CATEGORY_SEO_SETTINGS[categoryKey]
    : undefined;

  return mergeSeoSettings(serviceSettings, categorySettings);
}

export function getSeoSettingsForCategory(
  categoryPathName: string,
): SeoSettings {
  const categoryKey = CATEGORY_PATH_TO_KEY_MAP[categoryPathName];
  return categoryKey
    ? CATEGORY_SEO_SETTINGS[categoryKey]
    : DEFAULT_SEO_SETTINGS;
}

export const SEO_EXPLORE_PAGE_MAP: Record<string, SeoSettings> = {
  // Categories
  ...Object.entries(CATEGORY_PATH_NAMES).reduce((acc, [key, pathName]) => {
    acc[pathName] =
      CATEGORY_SEO_SETTINGS[key as keyof typeof CATEGORY_PATH_NAMES];
    return acc;
  }, {} as Record<string, SeoSettings>),
  // Services (merged with categories)
  ...Object.entries(SERVICE_PATH_NAMES).reduce((acc, [, pathName]) => {
    acc[pathName] = getSeoSettingsForService(pathName);
    return acc;
  }, {} as Record<string, SeoSettings>),
  default: DEFAULT_SEO_SETTINGS,
};

export const ENGLISH_LANGUAGE_CODE = 'en';

export const ALTERNATE_LANGUAGES = [
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fr',
  'hi',
  'id',
  'it',
  'ja',
  'ko',
  'nl',
  'no',
  'pl',
  'pt',
  'ru',
  'sv',
  'th',
  'tr',
  'uk',
  'vi',
  'zh',
];

export const TAX_INCLUSIVE_COUNTRIES = ['IL', 'AU', 'DE', 'FR'];

export const PROFILE_NOT_FOUND = 'NOT_FOUND';
export const PROFILE_NOT_EU_VALID = 'NOT_EU_VALID';
export const TEMPLATE_NOT_FOUND = 'NOT_FOUND';

export const INVALID_ARGUMENT = 'INVALID_ARGUMENT';

export const DEFAULT_PRICING = { min: MIN_PRICE, max: NaN };

export const KeyCodeEnter = 13;

export const ClientStatus = {
  REQUEST_SENT: 'REQUEST_SENT',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLTETD',
  CANCELED: 'CANCELED',
};

export const PROJECT_PAGE = 'client-project-page';
export const MY_PROJECTS_PAGE = 'my-projects-page';

export const DESKTOP = 'desktop';
export const MOBILE = 'mobile';

export const CANCELATION_REASON_KEYS = {
  NO_NEED: {
    key: 'client-dashboard-client-projects-cancel-option-no-need',
    biReason: 'I dont need it anymore',
  },
  HIRED_SOMEONE_ELSE: {
    key: 'client-dashboard-client-projects-cancel-option-hired-someone-else',
    biReason: 'I hired someone else',
  },
  FOUND_CHEAPER: {
    key: 'client-dashboard-client-projects-cancel-option-someone-less-expensive',
    biReason: 'I found someone else less expensive',
  },
  SELF_MADE: {
    key: 'client-dashboard-client-projects-cancel-option-self-made',
    biReason: 'I decided to do it myself',
  },
  TOO_EXPENSIVE: {
    key: 'client-dashboard-client-projects-cancel-option-expensive',
    biReason: 'Its too expensive',
  },
};
export const CAPSULE_EXPIRATION_IN_SECONDS = 60 * 60; // 60 minutes
export const DATA_CAPSULE_KEY_FOR_BRIEF_PAGE_SUBMITTED =
  'briefPageSubmittedDetails';

export const MORE_DETAILS_SLUG = 'more-details';
export const SITE_SELECTOR_SLUG = 'site-selector';
export const SEO_SERVICES_SLUG = 'seo-services';

export const MOBILE_VIEW_SIZE = '1000px';
export const MAX_CHARACTER_LIMIT_FOR_SITE_NAME = 20;

export const Sections = {
  EMPTY: '',
  ABOUT: 'about',
  FEATURED: 'featured',
  REVIEWS: 'reviews',
};

export const PROFILE_PAGE_SECTIONS = {
  EMPTY: '',
  ABOUT: 'about',
  CLIENT_PROJECTS: 'client-projects',
  SERVICES_AND_REVIEWS: 'services-and-reviews',
  REVIEWS: 'reviews',
  SERVICES: 'services',
  TEMPLATES: 'templates',
} as const;

export const PROFILE_REVIEWS_PER_PAGE = 6;
export const PROFILE_REVIEWS_MAX_PER_COLUMN = 3;

export const PROFILE_CLIENT_PROJECTS_LAYOUT_TYPE = {
  THREE_COLUMN: 'threeColumn',
  TWO_COLUMN: 'twoColumn',
} as const;

export type ProfileClientProjectsLayoutType =
  (typeof PROFILE_CLIENT_PROJECTS_LAYOUT_TYPE)[keyof typeof PROFILE_CLIENT_PROJECTS_LAYOUT_TYPE];

export const PROFILE_CLIENT_PROJECTS_IMAGE_DIMENSIONS = {
  TWO_COLUMN: { width: 1031, height: 579 },
  THREE_COLUMN: { width: 675, height: 379 },
} as const;

export const profileReviewsSectionTranslations = {
  viewReviewSubjectCTA: 'profile-page-review-project-link',
  replyAuthorTitle: 'profile-page-review-reply-title',
  noReviews: 'profile-page-reviews-section-no-reviews-text',
  reviewsSectionTitle: 'profile-page-reviews-section-title',
};

export const templateReviewsSectionTranslations = {
  viewReviewSubjectCTA: 'marketplace.templates-page.view-site-cta',
  replyAuthorTitle: 'marketplace.template-page.reply-title',
  noReviews: 'marketplace.templates-page.no-reviews-text',
  reviewsSectionTitle: 'marketplace.template-page.reviews-title',
};

export const PARTNER_DISPUTE_DEEP_LINK = 'reportPartnerDispute';

export const ENABLE_DEEP_LINK_TO_MORE_INFO_STEP_SPEC =
  'specs.experts.EnableBriefDeepLinkToMoreInfoStep';

export const PARTNERS_MARKETPLACE_GETUSERDETAILS_PERMISSIONS =
  'PARTNERS.MARKETPLACE.GETUSERDETAILS';

export const ENABLE_MARKETPLACE_TEMPLATES_DEBUG_MODE =
  'specs.marketplace.enableMarketplaceTemplatesDebugMode';

export const ENABLE_TEMPLATES_SORT_BY_BEST_SELLER =
  'specs.marketplace.enableSortByBestSeller';

export const ENABLE_REPORT_TEMPLATE = 'specs.experts.marketplaceReportTemplate';

export const ENABLE_BRIEF_AI_SPEC = 'specs.marketplace.EnableBriefAI';

export const NEW_COMMUNITY_POET_SPEC = 'specs.experts.newCommunityPost';

export const ENABLE_BRIEF_REDUCE_SERVICES =
  'specs.experts.briefReduceAutomatchServicesTake2';

export const ENABLE_BRIEF_REDUCED_SERVICES_WITH_CREATE_APP =
  'specs.marketplace.briefReduceAutomatchServicesAddCreateApp';

export const ENABLE_BRIEF_AUTO_MATCH_V3 =
  'specs.experts.briefReduceAutomatchServicesTake3';

export const ENABLE_VELO_MODAL_NEW_CONTENT =
  'specs.experts.templatesVeloModalNewContent';

export const ENABLE_CREATE_ORDER_ON_FREE_LISTING =
  'specs.marketplace.enableCreateOrderOnFreeListing';

export const ENABLE_CREATE_CART_V2 = 'specs.marketplace.enableCreateCartV2';

export const ENABLE_AGENCY_PROFILE_CONTACT_FORM =
  'specs.marketplace.enableAgencyProfileContactForm';

export const ENABLE_PROFILE_PROJECT_DEEPLINK_COPY_BUTTON =
  'specs.marketplace.enableCopyProfileProjectDeeplink';

export const ENABLE_TEMPLATE_PRICE_TAX_EXCLUSIVE_NOTE =
  'specs.marketplace.enablePriceTaxExclusiveNote';

export const HIDE_TEMPLATE_COUNT_DISPLAY_SPEC =
  'specs.marketplace.hideTemplateCountDisplay';

export const ENABLE_TEMPLATE_VIEW_PROFILE_LINKS_TO_AGENCY_PAGE =
  'specs.marketplace.templateViewProfileLinkToAgencyPage';

export const ENABLE_MARKETPLACE_BRIEF_AUDIT_CHANGES =
  'specs.marketplace.marketplaceBriefProductAuditChanges';

export const ENABLE_BRIEF_SAME_PAGE_RESULTS =
  'specs.marketplace.enableBriefSamePageResults';

export const ENABLE_MP_HEADER_APPLY_TO_MP_CTA =
  'specs.marketplace.enableMPHeaderApplyToMarketplaceCTA';

export const ENABLE_STUDIO_COMMUNITY_HEADER =
  'specs.marketplace.enableStudioCommunityHeader';

export const CUSTOM_CODE_KB_LINK =
  'https://wix.com/support/html5/article/wix-studio-about-custom-code-in-marketplace-templates';

export const PARTNER_DISPUTE_KB_LINK =
  'https://wix.com/support/html5/article/disputes-with-a-wix-professional';

export const DEMO_AGENCY_ID = '88dde794-ec28-4156-8182-a0008d51e89d';
